export class CancellationSetting {
    isCustom: boolean;
    cancellationPeriod: string;
    customHours: number;
}